export const formatDateOnly = (value) => {
	if (!value) {
		return "";
	}

	return String(value).split("T")[0];
};

export const formatDateTime = (value) => {
	if (!value) {
		return "-";
	}

	const parsedDate = new Date(value);

	if (Number.isNaN(parsedDate.getTime())) {
		return value;
	}

	return parsedDate.toLocaleString();
};

export const toApiDate = (value) => {
	if (!value) {
		return null;
	}

	return value.includes("T") ? value : `${value}T00:00:00.000Z`;
};

export const formatLeagueCellValue = (key, value) => {
	if (value === null || value === undefined || value === "") {
		return "-";
	}

	if (key === "startDate" || key === "endDate") {
		return formatDateOnly(value);
	}

	if (/ImportedOn$/i.test(key)) {
		return formatDateTime(value);
	}

	if (typeof value === "boolean") {
		return value ? "true" : "false";
	}

	return String(value);
};